<template>
  <div class="list">
    <div class="breadcrumb">
      <div class="breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item>订单管理</Breadcrumb-item>
          <Breadcrumb-item>订单列表</Breadcrumb-item>
          <Breadcrumb-item>学生合同</Breadcrumb-item>
        </Breadcrumb>
      </div>
    </div>
    <Row>
      <Col :span="4">
        <Select v-model="formData.contractVersionId" @on-change="onChange">
          <Option v-for="item in formData.versionList" :value="item.id" :key="item.id">{{ item.title}}</Option>
        </Select>
      </Col>
    </Row>
   <Row>
     <quillEditor v-model="formData.contract" ref="myQuillEditor" :options="editorOption"
                  @change="textChange"></quillEditor>
   </Row>
    <div slot="footer" :style="{ marginTop: '10px' }">
      <Button type="text" size="large" @click="onBack">取消</Button>
      <Button type="primary" size="large" @click="openPreview" :style="{ marginLeft: '10px', marginRight: '10px'}">预览</Button>
      <Button type="primary" size="large" :loading="loadingInsert" @click="saveData">保存</Button>
    </div>
  </div>
</template>
<script>
import * as Quill from 'quill'
import {quillEditor} from 'vue-quill-editor'

var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  components: {
    quillEditor,
  },
  name: 'StudentContract',
  data() {
    return {
      loadingInsert: false,
      reload: 0,
      currentVersionId: '',
      currentContract: '',
      formData: {
        fundPackageId: '',
        contract: '',
        uid: '',
        contractVersionId: '',
        versionList: [],
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{'header': 1}, {'header': 2}],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'indent': '-1'}, {'indent': '+1'}],
              [{'size': ['small', false, 'large', 'huge']}],
              [{'header': [1, 2, 3, 4, 5, 6, false]}],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              [{'font': fonts}],
              ['clean'],
              ['link', 'image', 'video']
            ],
          },
        }
      }
    }
  },
  mounted: function () {
    let self = this
    self.formData.fundPackageId = this.$route.query.row.id
    if (self.formData.fundPackageId === undefined){
      this.$router.go(-1)
      return
    }
    self.formData.uid = this.$route.query.row.uid
    self.$http.get('/fundPackage/getContract?fundPackageId=' + self.formData.fundPackageId).then(function (res) {
      if (res.data.fundPackageId) {
        self.currentVersionId = res.data.contractVersionId
        self.currentContract = res.data.contract
        self.formData = res.data
      } else {
        self.formData.versionList = res.data.versionList
      }
    })
  },
  created: function () {
  },
  methods: {
    onChange (val) {
      this.formData.versionList.forEach(v => {
        if (v.id === val && this.currentVersionId !== v.id) {
          this.formData.contract = v.contract
        } else if (v.id === val && this.currentVersionId === v.id) {
          this.formData.contract = this.currentContract
        }
      })
    },
    onBack () {
      this.$router.go(-1)
    },
    openPreview () {
      const contract = this.$refs.myQuillEditor.quill.root.innerHTML
      let url = `https://test-h5.kouyujie.cn/contract/contract.html`
      if (this.$appConfig.active === 'prod') {
        url = `https://h5.speakstreet.cn/contract/contract.html`
      }
      const newWindow = window.open(url, '_blank')
      setTimeout(() => {
        newWindow.postMessage({type: 'SET_CONTENT', contract}, '*')
      }, 1000)
    },
    textChange(val) {

    },
    saveData() {
      let self = this
      self.loadingInsert = true
      self.$http.post('/fundPackage/editContract', {
        fundPackageId: self.formData.fundPackageId,
        contract: self.formData.contract,
        uid: self.formData.uid,
        contractVersionId: self.formData.contractVersionId,
      }).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('保存成功!')
          self.$router.go(-1)
        }
        self.loadingInsert = false
      }).catch(function (e) {
        console.log(e)
        self.loadingInsert = false
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// StudentContract.vue?a417478a